import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { orderActions } from "../../../../../store/orders-slice"
import { productActions } from "../../../../../store/products-slice"

const Resort = (props) => {
       const { type, name } = props
       const { resort } = useFilter()
       let filteredproducts = useSelector((state) => state.product.filteredProducts)
       let products=useSelector(state=>state.product.products)
       let dispatch = useDispatch()
   
       return <Fragment>
           <label>{name}</label><select className="mb-2"
               onChange={(event) => {
                   let value = event.target.value
   
                   switch (value) {
                       case 'ASC':
                           dispatch(productActions.setFilteredItems(resort(filteredproducts??products, type, 'ASC')))
                           break
   
                       case 'DESC':
                           dispatch(productActions.setFilteredItems(resort(filteredproducts??products, type, 'DESC')))
                           break
                   }
   
               }}
   
           >
               <option value='' >Sort</option>
               <option value='ASC' >Ascending</option>
               <option value='DESC' >Descending</option>
           </select>
       </Fragment>
}

export default Resort